import styled from 'styled-components';

import { RewardsStyleVariant } from '../reward-categories/types';

export const SectionHeader = styled.h2<{ variant?: RewardsStyleVariant }>`
  margin: 0;
  padding-top: 16px;
  text-align: center;
  font-size: 1.5rem;
  color: ${({ variant = RewardsStyleVariant.Primary }) =>
    variant === RewardsStyleVariant.Primary ? Styles.color.white : Styles.color.secondary};

  ${Styles.mobileTiny`
    font-size: 1.375rem;
  `}
`;

export default SectionHeader;
